// // 首页
// import type { RouteRecordRaw } from 'vue-router'
// import { defaultLayout } from '@/router/base'

// const routes: RouteRecordRaw[] = [
//   {
//     path: '/demo',
//     name: 'Demo',
//     component: defaultLayout,
//     meta: {
//       locale: 'common.menus.home',
//       requiresAuth: true,
//       icon: 'home',
//       hideChildrenInMenu: true,
//       activeMenu: 'Home',
//       order: 7,
//     },
//     children: [
//       {
//         path: '',
//         name: 'DemoIndex',
//         component: () => import('@/views/example/index.vue'),
//         meta: {
//           locale: 'common.menus.home',
//           requiresAuth: true,
//           roles: ['*'],
//           activeMenu: 'Home',
//           isTopMenu: true,
//         },
//       },
//     ],
//   },
// ]

// export default routes
export default []
